// extracted by mini-css-extract-plugin
export default {"showcaseDiv":"MerchShowcaseItem_showcaseDiv__nEikY","showcaseImg":"MerchShowcaseItem_showcaseImg__TIeuK","showcaseItemDetails":"MerchShowcaseItem_showcaseItemDetails__HrGRq"};